import React from 'react';
import './MeetingConclusion.scss';
import Participant from '../../../partials/Participant/Participant';


const MeetingConclusion = (props) => {
    
    return <div className="meeting-conclusion">
     

            <div className="content-container">
                <div className="convo-container">
                    <h2 className="section-header">CONVERSATION CONCLUSION:</h2>
                    <div>
                        {/* <p className="section-header">How did {props.teamMember.first}'s part of the meeting go?</p> */}
                        <p className="section-header">How did your part of the meeting go?</p>
                        <p className="section-body">{props.conclusionText.feedback}</p>
                    </div>
                    <div>
                        <p className="section-header">What happened next?</p>
                        <p className="section-body">{props.conclusionText.summary}</p>
                    </div>
                    {/* this button should setCurrentTeamMember */}
                </div>
                <div className="user-card">
                    {/* <p className='points-tally'>convo points: <span className="points">{props.convoPoints}</span>/35</p> */}
                    <Participant
                        data={props.data}
                        hasNameTag={true}
                        isYou={true}
                        teamMember={props.teamMember}
                    />
                </div>
            </div>
            <div className="button-container">
                <img src="media/img/buttons/next-btn.png" onClick={props.onConclusionClicked} />
            </div>
        </div>

};

export default MeetingConclusion;